const ToursList = [
  {
    id: "my-son-sanctuary-luxury-tour",
    name: "My Son Sanctuary Luxury Tour",
    price: [
      {
        price: 850000,
        unit: "Person",
        currency: "VND",
        description: "Adults, Children 10 years and older",
      },
      {
        price: 650000,
        unit: "Child",
        currency: "VND",
        description: "Children 4 to 9 years",
      },
      {
        price: 0,
        unit: "Child",
        currency: "VND",
        description: "Children younger than 4 years",
      },
    ],
    maxGroupSize: 12,
    tourSchedules: { start: "8 AM", end: "1:30 PM", scheduleName: "" },
    tourSummary: [
      "By following the trail of history, finding the vestiges of the ancients and reliving the memories of a civilization, we would understand more the value of life.",
      "We look forward to bringing you the most enjoyable experiences in your journeys by discovering the biggest center of Hindu temples in the central of Viet Nam named My Son, which was built around the 4th century. This would be a great chance to learn about the cultural diversity of Vietnam through 4000 years.",
      "With the combination of cultural tourism, culinary and sightseeing, we expect you to remember Viet Nam as a friendly, beautiful and diverse culinary culture country. Come and join us!",
    ],
    tourItinerary: [
      "Our guide pick you up at your hotel and depart to My Son Sanctuary – The World Cultural Heritage.",
      "Arrive at My Son and we’ll have 2 hours to discover the site by walking throughout the landscape, learning histories with our local English speaking guide, enjoying the Champa’s traditional performances.",
      "Get back to mini van and move to a local house to learn how to make ricepaper, you will enjoy your own hand-making product later on!",
      "Back to the van and have lunch at another local house, relax with cold herbal tea, nice foods and fresh air.",
      "Take a boat trip to Hoi An with nice and cool breeze on boarding, beautiful river scenery on the biggest river in the Central of vietnam named as Thu Bon River.",
      "Arrive at Hoi An, we will drop you at your hotel. Tour ends!",
    ],
    tourIncludes: [
      "A two ways hotel transfers pick up and drop off (100km round trip distance)",
      "The 150,000 VND entrance fees and 30,000 VND of electric car transfer",
      "Lunch will be served with Vietnamese Traditional foods",
      "Boat trip on Thu Bon River",
      "English speaking guide",
      "A bottle of water",
    ],
    tourExcludes: [
      "Personal expense services not mentioned above",
      "Drinks",
      "Tips and gratuities for guides and drivers",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "This tour is not available during Tet holiday period",
    ],
    tourImages: ["/assets/tours/my-son-1.jpg"],
  },
  {
    id: "my-son-sunset-tour",
    name: "Amazing My Son Sunset Tour",
    price: [
      {
        price: 500000,
        unit: "Person",
        currency: "VND",
        description: "Adults, Children 10 years and older",
      },
      {
        price: 400000,
        unit: "Child",
        currency: "VND",
        description: "Children 4 to 9 years",
      },
      {
        price: 0,
        unit: "Child",
        currency: "VND",
        description: "Children younger than 4 years",
      },
    ],
    minGroupSize: null,
    maxGroupSize: 14,
    tourSchedules: { start: "1:30 PM", end: "6:30 PM", scheduleName: "" },
    tourSummary: null,
    tourPolicy: null,
    tourIncludes: [
      "Transfer to and from hotel (100km round trip)",
      "A Boat Trip on the Thu Bon River",
      "English speaking tour guide",
      "A bottle of water",
    ],
    tourExcludes: [
      "Entrance Fee of 150,000 VND",
      "Personal expenses not mentioned above",
      "Drinks",
      "Tips & gratuities for guides and drivers",
    ],
    tourItinerary: [
      "1:30 PM - 2:00 PM: Our tour guide will pick you up at the hotel and deport to My Son Sanctuary - The World Cultural Heritage",
      "3:00 PM: Arrive at My Son and you'll have 2 hours to discover the site by walking throughout the landscape. Our English speaking tour guide will go over the history of My Son and you'll have the opportunity to enjoy the Champa's traditional performance",
      "5:15 PM: Depart from My Son and transfer to the wharf where you will take a boat trip to Hoi An. While on the boat you'll enjoy the beautiful sunset on the Thu Bon River, which is biggest river in the central area of Vietnam. This will be time to get your camera ready and capture some of the local people going about their day along the river",
      "6:30 PM: Arrive back in Hoi An, you'll be dropped back off at your Hotel. Tour Ends!",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "The Tour will not be offered during Tet holiday period",
    ],
    tourImages: ["/assets/tours/my-son-sunset-1.jpg"],
  },
  {
    id: "ba-na-hills-golden-bridge-day-tour",
    name: "Ba Na Hills - Golden Bridge Day Tour",
    price: [
      {
        price: 1375000,
        unit: "Person",
        currency: "VND",
        description: "Adults (height greater than 1.4 meters",
      },
      {
        price: 1195000,
        unit: "Child",
        currency: "VND",
        description:
          "Children (height greater than 1 meter, but less than 1.4 meters",
      },
      {
        price: 0,
        unit: "Child",
        currency: "VND",
        description: "Children less than 1 meter in height",
      },
    ],
    minGroupSize: null,
    maxGroupSize: 12,
    tourSchedules: { start: "7 AM", end: "6:45 PM", scheduleName: "" },
    tourSummary: null,
    tourPolicy: [
      "There is a 20% cancellation fee for canceling 12 hours before the start of the tour",
      "There is a 35% cancellation fee for canceling on the day of the tour",
    ],
    tourIncludes: [
      "Round trip transportation (120km round-trip)",
      "Ba Na Hill Entrance and cable car fees",
      "Buffet lunch",
      "English speaking tour guide",
      "a bottle of water",
    ],
    tourExcludes: [
      "The 100,000 VND Wax Museum entrance fee",
      "Personal expenses and services not mentioned above",
      "Tips and gratuities for guide and driver",
    ],
    tourItinerary: [
      "7:30 AM - 8:00: Our Minivan and our guide pick you up at hotel lobby",
      "9:30 AM: Arrive at Ba Na Hills via Cable Cars",
      "After finishing the first cable car, you will visit the Golden Bridge. The Golden Bridge is the world's most prominent pedestrian bridges as highlighted by the British Guard newspaper. After the golden bridge you will have the opportunity to visit the French wine cellar, Le Jardin D'amourn, Linh Ung Pagoda",
      "Continue your journey by taking the second cable car to visit the French Village, Campanile, Nine Floor Goddess Shrine, Tombstone Temple, Linh Phong Monastery, Linh Chua Linh Tu Temple, and Tru Vu Tea Shop.",
      "Ride the Alpine coaster",
      "Around 12:00 PM: Buffet lunch will be provided",
      "After lunch, you can continue to explore Ba Na Hill's many attractions",
      "3:00 PM: Return to cables car and leave Ba Na Hills",
      "4:45 PM - 5:45 PM: Our minivan brings you back to your hotel and the tour ends",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "The Tour will not be offered during Tet holiday period",
    ],
    tourImages: ["/assets/tours/ba-na-bridge-sunset.jpg"],
  },
  {
    id: "cooking-class",
    name: "Cooking Class at Moon River Restaurant",
    price: [
      { price: 750000, currency: "VND", unit: "Person", description: "" },
    ],
    minGroupSize: 2,
    maxGroupSize: null,
    tourSchedules: [
      { start: "9:30 AM", end: "1:00 PM", scheduleName: "Morning" },
      { start: "3:30 PM", end: "7:00 PM", scheduleName: "Afternoon" },
    ],
    tourSummary:
      "Understanding food is a great way to experience the fascinating culture of Vietnam.",
    tourPolicy: null,
    tourIncludes: null,
    tourExcludes: null,
    tourItinerary: [
      "Starts with a visit to the local market in the center of the city",
      "With our Chef as your guide you will select ingredients to use during the cooking class",
      "Once you've completed your trip to the local market, you will come back to the hotel and cooking class will begin",
    ],
    tourNotes: "Please schedule one day in advance",
    tourImages: ["/assets/restaurant/cooking-2.jpg"],
  },
  {
    id: "experience-eco-fishing-village-tour",
    name: "Experience Eco Fishing Village Tour",
    price: [
      { price: 700000, currency: "VND", unit: "Person", description: "Adults" },
      {
        price: 350000,
        currency: "VND",
        unit: "Child",
        description: "children 5 to 11 years old",
      },
      {
        price: 0,
        unit: "Unit",
        currency: "VND",
        description: "Children under 5 years",
      },
    ],
    minGroupSize: 2,
    maxGroupSize: null,
    tourSchedules: [
      { start: "8:30 AM", end: "1:00 PM", scheduleName: "Morning" },
      { start: "2:00 PM", end: "6:30 PM", scheduleName: "Afternoon" },
    ],
    tourSummary:
      " Come to join this special Tour you will enjoy a wide range of experiences – from learning traditional fishing techniques to paddling the strange and unique Vietnamese bamboo basket boats and normal fishing boats of the local fishermen while exploring the Ecological water palm system where was the safe and important revolutionary base of V.C soldiers in the past war. On this tour we provide an authentic social and cultural insight into the local Vietnamese way of life. As well you will take part in some hands-on activities that are fun, safe and interesting to people all of ages.",
    tourPolicy: null,
    tourIncludes: [
      "Afternoon tours include a Hoi An traditional dinner",
      "Morning tours include a Hoi An traditional lunch",
      "Cold Water",
      "English speaking tour guide",
      "Boat and Bicycle Transportation",
      "Roundtrip transportation",
    ],
    tourExcludes: ["Anything not mentioned in the inclusions section"],
    tourItinerary: [
      "Pick up at hotel by bicycle then cycle  to a local fishing village named Cam Thanh",
      "Riding pass narrow roads through a small local market, stop at rice paddy field, taking many pictures of water buffalos, farmers on daily working at their fields, fish and shrimp-ponds",
      "Learning how hard working of local farmers by ploughing the field, planting baby rice, riding water buffalo",
      "Learn about daily life of Vietnamese fishermen, their families and their community",
      "Joining with local fishermen on Cua Dai river and learn how to use the round net and cast net fishing",
      "Learning to paddle unique Vietnamese Bamboo Basket boats",
      "Explore the Ecological water palm system, get to know more about the true stories that happened here during war time and  hear of the extreme conditions endured by soldiers of both sides, hard work fishermen on this river for a long time.",
      "Back to a local family (Mr Cu’s home) for a local lunch, learn how to make traditional rice milk and cook traditional Hoi An pancake (Banh Xeo)",
      "Tour ends by noon then return back to hotel.",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "The Tour will not be offered during Tet holiday period",
    ],
    tourImages: ["/assets/tours/eco-fishing-1.jpg"],
  },
  {
    id: "cham-island-diving-snorkeling-tour",
    name: "Cham Island Diving – Snorkeling Tour",
    price: [
      {
        price: 1200000,
        currency: "VND",
        unit: "Person",
        description: "Snorkeling and island excursion",
      },
      {
        price: 1800000,
        currency: "VND",
        unit: "Person",
        description: "1 beginner dive for non-certified divers",
      },
      {
        price: 2300000,
        currency: "VND",
        unit: "Person",
        description: "2 beginner dives for non-certified divers",
      },
      {
        price: 2100000,
        currency: "VND",
        unit: "Person",
        description: "2 dives for certified divers",
      },
    ],
    minGroupSize: 2,
    maxGroupSize: null,
    tourSchedules: [{ start: "8:00 AM", end: "5:00 PM", scheduleName: "" }],
    tourSummary: null,
    tourPolicy: null,
    tourIncludes: ["All equipment for diving or snorkeling", "Lunch"],
    tourExcludes: ["Anything not mention in the inclusions"],
    tourItinerary: [
      "8:00 AM - 8:30 AM: Leave the hotel by minivan",
      "8:45 AM: Boat departs from Cua Dai pier for Cham Island",
      "10:00 AM: Snorkeling 1 / Dive 1",
      "12:00 PM: Snorkeling 2 / Dive 2",
      "1:30 PM: Lunch on Bai Chong tropical beach",
      "2:00 PM- 3:30 PM: Time for exploring the beach or resting in the provided hammocks",
      "3:45 PM: Board the boat to leave Cham Island",
      "5:00 PM: Arrive back at your hotel in Hoi An, ",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "The Tour will not be offered during Tet holiday period",
    ],
    tourImages: ["/assets/tours/cham-island-1.jpg"],
  },
  {
    id: "basket-boat-fishing-and-cooking-experience",
    name: "Basket Boat Fishing And Cooking Experience",
    price: [
      {
        price: 650000,
        currency: "VND",
        unit: "Person",
        description: "Adults",
      },
      {
        price: 325000,
        currency: "VND",
        unit: "Child",
        description: "children 5 to 11 years old",
      },
      {
        price: 0,
        currency: "VND",
        unit: "Child",
        description: "children under 5 years old",
      },
    ],
    minGroupSize: 2,
    maxGroupSize: null,
    tourSchedules: [
      { start: "8:30 AM", end: "1:00 PM", scheduleName: "Morning" },
      { start: "2:00 PM", end: "6:30 PM", scheduleName: "Afternoon" },
    ],
    tourSummary: null,
    tourPolicy: null,
    tourIncludes: [
      "Hoi An traditional lunch (morning tours) /dinner (afternoon tours)",
      "Cold water",
      "English speaking tour guide",
      "Bicycle transportation",
      "Entrance fees",
      "Roundtrip transportation",
    ],
    tourExcludes: ["Anything not mention in the inclusions"],
    tourItinerary: [
      "Tour guide pick up you at the hotel lobby, then get to Thu Bon wharf on Bach Dang Street near Hoi An central market.",
      "Joining a boat cruise along the major branch of the lower section of Thu Bon river, enjoy the beautiful scenery along both banks of this river where you watch many boats bobbing on the waters, local fishermen are on their daily work of catching fishes, mussel,. After that, we will cross Cua Dai estuary where the river meet the sea, going up to the Cua Dai river and heading for Bay Mau nipa (water coconut palm forest) grove where you can discover the daily life of the local fisherman there.",
      "Catch a Bamboo basket boat trip into water coconut palm forest with local fisherman",
      "Explore the water palm coconut paradise. Learning and sharing fishing experience with local fishermen by catching fish and purple crabs with unique fishing nets, make souvenirs with palm leaves.",
      "Get to know more about Vietnamese–American war, interesting & true stories happened during the war time.",
      "Having lunch or at the local home (Mr Cu’s home), learn how to make fresh rice milk and cook traditional Hoi An pancake (Banh Xeo).",
      "Tour ends by noon then return back to hotel.",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "The Tour will not be offered during Tet holiday period",
    ],
    tourImages: ["/assets/tours/basket-boat-1.jpg"],
  },
  {
    id: "marble-mountains-am-phu-cave-monkey-mountains",
    name: "Marble Mountains - Am Phu Cave - Monkey Mountains",
    price: [
      {
        price: 550000,
        currency: "VND",
        unit: "Person",
        description: "Adults",
      },
      {
        price: 375000,
        currency: "VND",
        unit: "Child",
        description: "children 4 to 9 years old",
      },
      {
        price: 0,
        currency: "VND",
        unit: "Child",
        description: "children under 4 years old",
      },
    ],
    minGroupSize: 2,
    maxGroupSize: null,
    tourSchedules: { start: "7:30 AM", end: "1:00 PM", scheduleName: "" },
    tourSummary: null,
    tourPolicy: null,
    tourIncludes: [
      "Roundtrip transportation (90 km total distance)",
      "Entrance fees for both Marble Mountains and Am Phu Cave",
      "English speaking tour guide",
      "Lunch with local cuisine",
      "A bottle of water",
    ],
    tourExcludes: [
      "Personal expenses for services not mentioned in the inclusions (such as the fee to use the elevator to the top of Marble Mountain)",
      "Tips for guide and driver",
    ],
    tourItinerary: [
      "7:30 AM - 8:00 AM: Depart hotel",
      "8:30 AM: Arrive in Marble Mountains and stop for a walk along the site to see the local factories of stone sculptures – the most impressive handicrafts village in Da Nang",
      "9:00 AM - 10:00 AM: check in the Marble Mountain by climbing up to the top (elevator is optional). Here we will see beautiful pagodas which were built from 19th century by the last dynasty of Vietnam monarchy, visit Huyen Khong and Tang Chon Caves",
      "10:30 AM - 11:00 AM: Keep going to see the biggest fascinated cave named as Am Phu. You will learn interesting philosophies of Buddhism and take photos with amazing natural creation",
      "11:00 AM: Have lunch at the local restaurant with local and authentic Vietnamese cuisines.",
      "11:45 AM: Our van will transfer you to the next stop – Monkey Mountain. A giant statue Lady Buddha with beautiful background such as mountains and huge garden of bonsai would draw your attention. You will definitely get lost in the garden of heaven with gripping stories when gently walking and enjoy a fresh breeze.",
      "1:00 PM: the tour will end and we will arrive back at your hotel.",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "The Tour will not be offered during Tet holiday period",
    ],
    tourImages: ["/assets/tours/marble-moutain-1.jpg"],
  },
  {
    id: "hue-city-tour",
    name: "Hue City Tour",
    price: [
      {
        price: 1050000,
        currency: "VND",
        unit: "Person",
        description: "Adults",
      },
      {
        price: 787500,
        currency: "VND",
        unit: "Child",
        description: "children 6 to 11 years old",
      },
      {
        price: 0,
        currency: "VND",
        unit: "Child",
        description: "children under 5 years old",
      },
    ],
    minGroupSize: 2,
    maxGroupSize: null,
    tourSchedules: { start: "7:00 AM", end: "7:15 PM", description: "" },
    tourSummary: null,
    tourPolicy: null,
    tourIncludes: [
      "Roundtrip transportation",
      "Dragon boat cruise",
      "Experienced tour guide",
      "Lunch",
      "All entrance fees",
      "2 bottles of drinking water",
    ],
    tourExcludes: ["Anything not mentioned in the inclusions"],
    tourItinerary: [
      "7:00 AM - 7:30 AM: Our tour guide will pick you up from your hotel and you'll begin your journey to Hue",
      "Enjoy one of the best coastal roads in the world Hai Van Pass",
      "30 minute stop at the peak and 5 minutes for photos at Lang Co Beach",
      "11:00 AM: Visit the Khai Dinh Tomb",
      "12:30 PM: Enjoy a delicious lunch at a Local Specialty Restaurant serving Hue style dishes.",
      "1:30 PM: Continue to Hue’s main attraction, the Imperial Citadel.",
      "3:00 PM: Explore Thien Mu Pagoda, Hue’s largest pagoda.",
      "4:00 PM: Cruise along the Perfume River by Dragon boat.",
      "4:30 PM: Begin your return trip to Hoi An",
      "7:15 PM: Arrive back at your hotel",
    ],
    tourNotes: null,
    tourImages: ["/assets/tours/hue-1.jpg"],
  },
  {
    id: "farming-fishinh-life-experience",
    name: "Farming & Fishing Life Experience",
    price: [
      { price: 700000, currency: "VND", unit: "Person", description: "Adults" },
      {
        price: 350000,
        currency: "VND",
        unit: "Child",
        description: "children 5 to 11 years old",
      },
      {
        price: 0,
        unit: "Unit",
        currency: "VND",
        description: "Children under 5 years",
      },
    ],
    minGroupSize: 2,
    maxGroupSize: null,
    tourSchedules: [
      { start: "8:30 AM", end: "1:00 PM", scheduleName: "Morning" },
      { start: "2:00 PM", end: "6:30 PM", scheduleName: "Afternoon" },
    ],
    tourSummary:
      "Cam Thanh village is about 5km from the old town. During the time of American-Vietnam war this was the shelter for local people and soldiers and nowadays this place is a famous destination for tourist. It is providing the most seafood products, fresh vegetable and also rice for this area and the whole Hoi An. Joining this tour you will have a good chance to meet lots of local villagers, learn some traditional fishing techniques like how to paddle the unique Vietnamese bamboo basket boats, exploring the now tranquil coconut-palm flanked waterways of a past war. During most the time of this tour, we provide an authentic social and cultural insight into the Vietnamese local way of life. As well you will take part in some hands-on activities that are fun,safe and interesting to people of all ages.",
    tourPolicy: null,
    tourIncludes: [
      "Afternoon tours include a Hoi An traditional dinner",
      "Morning tours include a Hoi An traditional lunch",
      "Cold Water",
      "English speaking tour guide",
      "Boat and Bicycle Transportation",
      "Roundtrip transportation",
      "Entrance fees",
    ],
    tourExcludes: ["Anything not mentioned in the inclusions"],
    tourItinerary: [
      "Meet your expert Guide at hotel then cycle on beautiful narrow road to local fishing village name Cam Thanh, stop at rice paddy field, fishes and shrimps farms...",
      "Visit an ancient cemetery, holy temples.",
      "Joining in a special farming work with the local farmer by ploughing the field, prepare the field then plant baby rice on the field where you just plough. You will have opportunity to ride on water buffalos and then feeding them, it is very interesting.",
      "Watching local people on  the work of making palm-thatched houses with water palm products and bamboo.",
      "Explore the water palm coconut paradise. Learning and sharing fishing experience with local fishermen by catching fish and purple crabs with unique fishing nets,  paddle the traditional Bamboo Basket boat. Make souvenirs with palm leaves.",
      "Get to know more about Vietnamese – American war, interesting & true stories  happened during the war time.",
      "Having Lunch at the local home ( Mr Cu’s home), learn how to make fresh rice milk and cook traditional Hoi An pancake (Banh Xeo).",
      "Tour ends, tour guide drops you off back to hotel.",
    ],
    tourNotes: [
      "This tour is sold and operated by an independent tour company.",
      "The Tour will not be offered during Tet holiday period",
    ],
    tourImages: ["/assets/tours/farming-fishing-1.jpg"],
  },
  {
    id: "traditional-countryside-bicycle-tour",
    name: "Traditional Countryside Bicycle Tour",
    price: [
      { price: 650000, currency: "VND", unit: "Person", description: "Adults" },
      {
        price: 430000,
        currency: "VND",
        unit: "Child",
        description: "children 6 to 12 years old",
      },
      {
        price: 90000,
        currency: "VND",
        unit: "Child",
        description: "children 4 to 5 years old",
      },
      {
        price: 0,
        unit: "Unit",
        currency: "VND",
        description: "Children under 4 years",
      },
    ],
    minGroupSize: 2,
    maxGroupSize: 10,
    tourSchedules: { start: "8:30 AM", end: "3:00 PM", scheduleName: "" },
    tourSummary: [
      "Spend a day leisurely cycling though the scenic countryside of Vietnam, far from the traffic the motor scooters, and the noises the city. You will cross the islands on the Song Thu river delta using local transportation, including ferries and floating bridge.",
      "This tour will take you to discover how wooden river boats are made, learn the secret of weaving the colorful straw Hoi An sleeping mats Try the renowned Vietnamese basket boats. You will spend the day with first-hand contact with one of the rural inhabitant of the region, far from the usual tourist circuits.",
      "At lunchtime you will be invited into the home of a local Vietnamese family for a traditional Vietnamese meal, and learn their customs and traditions. After you have relaxed for a while under the shade of a mango tree, you will Begin your return towards Hoi An, which will take about an hour.",
    ],
    tourPolicy: null,
    tourIncludes: [
      "Bicycles helmets (upon request)",
      "Bicycles with child or baby seat (upon request)",
      "Traditional home cooked meal from a local Vietnamese family (choice of meat, fish or vegetarian)",
      "French or English speaking tour guide (please indicate which you would prefer when booking)",
      "A assistant guide for tour groups larger than 3 people",
    ],
    tourExcludes: ["Hats or Caps", "Sunscreen", "Sunglasses"],
    tourItinerary: null,
    tourNotes: [
      "Children 6 years and older will be provided a children's bike",
      "Children younger than 6 and older than 2 will be passengers",
      "Tandem bicycles available upon request",
      "Please bring the following: Sunscreen, Hat, Sun glasses and if November, December or January a Windbreaker",
      "This tour is 9 km with several stops, the path that the guide will follow is flat and meant for riders of all abilities and ages.",
    ],
    tourImages: ["/assets/tours/bicycle-tour-1.jpg"],
  },
];

const getTourData = () => {
  return ToursList;
};

const getTour = (id) => {
  const found = ToursList.find((tour) => tour.id === id);
  return found;
};

module.exports = { getTourData, getTour };
